import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TextInput,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import valueHelpers from "app/utils/valueHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";

import Form from "app/components/Form";

export default class EditView extends React.Component {
  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation

    let { navigation, route } = this.props;
    const { value, id } = !!route && route.params ? route.params : {};
    // console.log(value);
    this.state = {
      id,
      // value,
      value: {},
      submitting: false,
      error: false,
      fetching: !value?.id,
    };
  }

  async componentDidMount() {
    let { id, value } = this.state;
    let res = await valueActions.getRaw(id);
    if (!!res?.success) {
      let fam = await valueActions.getFamily(id, { up: 1, down: 1 });
      console.log("fetched value:", value);
      this.setState({ value: res.value, fetching: false });
    } else {
      this.setState({ fetching: false, error: true });
    }
  }

  handleSubmit = async () => {
    console.warn("submit");
    this.setState({ submitting: true });
    let { value } = this.state;
    console.log("submitting", value);
    // value = await apiActions.request(`values/${value.id}`, 'PATCH', {value})
    let success = await valueActions.update(value.id, value);
    if (!!value) {
      // await valueActions.updateValues(value)
      RootNavigation.navigate("Project", { id: value.id });
    } else {
      this.setState({ submitting: false, error: true });
    }
  };

  handleSubmitAllRevisions = async () => {
    this.setState({ submitting: true });
    let { value } = this.state;
    // this will only add parent_ids and modify symbol
    value = await apiActions.request(
      `values/${value.id}/update_all_revisions`,
      "PATCH",
      { value },
    );
    if (!!value) {
      await valueActions.updateValues(value);
      RootNavigation.navigate("Project", { id: value.id });
    } else {
      this.setState({ submitting: false, error: true });
    }
  };

  handleDelete = async () => {
    this.setState({ submitting: true });
    let { value } = this.state;
    let success = await valueActions.delete(value);
    if (success) this.props.navigation.goBack();
    else {
      this.setState({ submitting: false, error: true });
    }
  };

  handleChangeValue = (key, val) => {
    let { value } = this.state;
    value[key] = val;
    this.setState({ value });
  };

  render() {
    let { navigation, route } = this.props;
    let { value, submitting, fetching } = this.state;
    if (fetching) return null;
    return (
      <Form
        value={value}
        onChangeValue={this.handleChangeValue}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        onSubmitAllRevisions={this.handleSubmitAllRevisions}
        submitting={submitting}
        allowUpdateAllRevisions
        fetching={fetching}
        // route={route}
        // navigation={navigation}
      />
    );
  }
}
